import Chip from 'components/ui/Chip';
import PageSubHeading from './PageSubHeading';
import Badge from 'components/ui/Badge';
import Card from 'components/ui/Card';
import EmptyState from 'components/ui/EmptyState';
import { FocusTemplateDetailsListType } from 'enums';
import { t } from 'services/i18n.service';

interface Props {
  title: string;
  allowed_list: string[];
  type: FocusTemplateDetailsListType;
}

const DetailsPageListItem = ({ title, allowed_list, type }: Props) => {
  if (!allowed_list.length) {
    return (
      <EmptyState
        title={
          type === FocusTemplateDetailsListType.ALLOWED_APPS
            ? t('market.no_allowed_list')
            : t('market.no_allowed_urls')
        }
      />
    );
  }

  return (
    <Card className='w-full flex flex-col ~gap-2/4' variant='outlined'>
      <PageSubHeading text={title} />
      <div className='flex flex-wrap ~gap-2/4'>
        {allowed_list.map((item, index) =>
          type === FocusTemplateDetailsListType.ALLOWED_APPS ? (
            <Badge key={`${item}-${index}`} size='sm' variant='secondary'>
              {item}
            </Badge>
          ) : (
            <Chip key={`${item}-${index}`} text={item} variant='filled' />
          )
        )}
      </div>
    </Card>
  );
};

export default DetailsPageListItem;
